import { render, staticRenderFns } from "./patch.vue?vue&type=template&id=b0f41bc0&scoped=true&"
import script from "./patch.vue?vue&type=script&lang=js&"
export * from "./patch.vue?vue&type=script&lang=js&"
import style0 from "./patch.vue?vue&type=style&index=0&id=b0f41bc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f41bc0",
  null
  
)

export default component.exports